import { useTranslation } from "react-i18next";

const useFormatCondition = () => {
    const { t } = useTranslation();

    const formatCondition = (condition: string) => {
        const conditionArray = condition.split(" ");

        const formattedCondition = conditionArray.map(item => {
            const cleaned = item.replace(/[\[\]'"`,.:;!?(){}]/g, "");
            return t(`conditions.${cleaned}`);
        });

        return formattedCondition.join(" ");
    };

    return formatCondition;
};

export default useFormatCondition;
